import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import { FormField, InputElement } from 'Components/FormComponents';

// TODO: maybe kill 'trim'

// RESOURCES:
// there are alternatives to intl-tel-input that are potentially better and/or smaller
// - https://github.com/catamphetamine/libphonenumber-js
// - https://github.com/ruimarinho/google-libphonenumber

const COUNTRY_CODES = intlTelInput.getCountryData().map(_ => _.iso2);

function isCountryCodeValid(cc) {
  return COUNTRY_CODES.includes(cc);
}

function getValidCountryCodes(codes) {
  if (!codes || !Array.isArray(codes)) {
    return [];
  }

  const ret = [];

  for (const cur of codes) {
    if (!cur || typeof cur !== 'string') {
      continue;
    }

    const cc = cur.toLowerCase();
    if (isCountryCodeValid(cc) && !ret.includes(cc)) {
      ret.push(cc);
    }
  }

  return ret;
}

export function FormTel(props) {
  const { form, inline = false, name, rootClass, label, comment = null, commentCol = false, value = '', readonly = false, inputAttributes, trim = true, defaultCountryCodes = null } = props;
  const id = form.getFieldId(name);

  const countryCodes = getValidCountryCodes(defaultCountryCodes);
  const [ defaultCountryCode = null ] = countryCodes;

  let el;
  let iti;

  const root = (
    <FormField inline={inline} id={id} rootClass={rootClass} label={label} comment={comment} commentCol={commentCol}>
      <InputElement type="tel" name={name} id={id} readonly={readonly} attributes={inputAttributes} ref={el} />
    </FormField>
  );

  form.addField(name, {
    root,
    el,
    label,
    getValue() {
      // TODO: technically getNumber() should not be called if
      // !isValidNumber() because it seems to just return whatever is
      // currently in the input if the number is not valid.

      // According to intl-tel-input docs: "Also note that this method
      // expects a valid number, and so should only be used after
      // validation."
      // However, we have to return some non-empty string or else the
      // ValidatedForm 'required' test will fail and checkValue()
      // won't be run.
      const value = iti.getNumber(intlTelInput.utils.numberFormat.E164);

      return trim
        ? value.trim()
        : value;
    },
    setValue(val) {
      iti.setNumber(val);
    },
    checkValue() {
      return iti.isValidNumber();
    },
  });

  iti = intlTelInput(el, {
    initialCountry: defaultCountryCode,
    countryOrder: countryCodes,
    // TODO: generate dynamically from intlTelInput.utils.numberType,
    // have a const that is a list of types to exclude
    validationNumberTypes: [
      'FIXED_LINE',
      'MOBILE',
      'FIXED_LINE_OR_MOBILE',
      'TOLL_FREE',
      'PREMIUM_RATE',
      'SHARED_COST',
      'VOIP',
      'PERSONAL_NUMBER',
      'PAGER',
      'UAN',
      'VOICEMAIL',
    ],
  });

  iti.setNumber(value);

  return root;
}
